import { CalendarDays, MapPin, Heart } from "lucide-react";
import { Reveal } from "./Reveal";

const SOUP_IMG = "https://images.pexels.com/photos/9873798/pexels-photo-9873798.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const Details = ({ party }) => (
  <section id="details" className="relative bg-[#5C6B3C] px-6 md:px-16 lg:px-24 py-24 md:py-36" data-testid="details-section">
    <Reveal x={-80}>
      <p className="font-body text-[11px] uppercase tracking-[0.35em] text-cream/70 mb-4">The Who, What & Where</p>
      <h2 className="font-display text-3xl md:text-5xl leading-tight tracking-tight text-cream max-w-2xl">
        One evening. Your best pot. <span className="italic text-harvest">Zero</span> leftovers wasted.
      </h2>
    </Reveal>

    <div className="mt-16 md:mt-24 grid grid-cols-1 md:grid-cols-12 gap-5">
      <Reveal className="md:col-span-5" delay={0.05}>
        <div className="notice-block p-8 md:p-10 h-full" data-testid="detail-when">
          <CalendarDays className="text-ember mb-6" size={26} />
          <p className="font-body text-[11px] uppercase tracking-[0.3em] text-fog mb-3">When</p>
          <p className="font-display text-2xl md:text-4xl text-cream leading-tight">{party?.date_display || "Saturday, October 3, 2026"}</p>
          <p className="font-display italic text-2xl md:text-3xl text-harvest mt-3">tasting begins at {party?.time_display || "5:00 PM"}</p>
        </div>
      </Reveal>

      <Reveal className="md:col-span-4" delay={0.12}>
        <div className="notice-block p-8 md:p-10 h-full" data-testid="detail-where">
          <MapPin className="text-ember mb-6" size={26} />
          <p className="font-body text-[11px] uppercase tracking-[0.3em] text-fog mb-3">Where</p>
          <p className="font-display text-2xl md:text-4xl text-cream leading-tight">{party?.location || "Aymond House"}</p>
          <p className="font-body text-sm text-fog mt-4 leading-relaxed">
            {party?.location_note || "18056 Shadow Creek Ave."}
            <br />
            {party?.location_city || "Baton Rouge, LA 70816"}
          </p>
        </div>
      </Reveal>

      <Reveal className="md:col-span-3 md:row-span-2" delay={0.18}>
        <div className="relative h-64 md:h-full overflow-hidden border border-forest group">
          <img
            src={SOUP_IMG}
            alt="A rustic bowl of autumn soup"
            className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0F110E]/80 to-transparent" />
        </div>
      </Reveal>

      <Reveal className="md:col-span-9" delay={0.24}>
        <div className="notice-block p-8 md:p-10" data-testid="detail-why">
          <Heart className="text-ember mb-6" size={26} />
          <p className="font-body text-[11px] uppercase tracking-[0.3em] text-fog mb-3">Why We Gather</p>
          <p className="font-body text-base md:text-lg text-fog leading-relaxed max-w-3xl">
            {party?.why ||
              "Because the best nights end with everyone's freezer full. Bring a pot of your favorite soup, taste your way down the table, then trade quarts and take home a little of everyone's."}
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
